module.exports = __webpack_public_path__ + "static/img/12.6b34572.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/12.jpg
// module id = EYeM
// module chunks = 0